import { evidenceThreads } from '@/mocks/gossip';

export default function Evidence() {
  return (
    <section id="evidence" className="bg-background-50 py-12 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-bold text-accent-600">
              <i className="ri-file-shield-2-line" />
              实锤专区 · 截图与记录
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              聊天记录与相关截图，全给你归档好
            </h2>
            <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
              爆料之外的聊天记录、群内投票和截图都汇总到这里，红脸归红脸，材料一张不少。
            </p>
          </div>
          <span className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-accent-200 bg-accent-50 px-4 py-2 text-xs font-bold text-accent-700">
            <i className="ri-shield-check-line" />
            记录均标时间戳
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {evidenceThreads.map((e) => (
            <article
              key={e.id}
              className="flex flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-50 transition hover:border-accent-200"
            >
              <div className="border-b border-background-100 bg-background-100/60 px-5 py-4">
                <p className="flex items-center gap-2 text-xs font-bold text-accent-700">
                  <i className="ri-hashtag text-sm" />
                  {e.cat}
                </p>
                <h3 className="mt-1.5 font-heading text-base font-black text-foreground-950">{e.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{e.desc}</p>
              </div>

              <div className="flex flex-1 flex-col gap-3 px-5 py-4">
                {e.lines.map((ln, i) => (
                  <div
                    key={i}
                    className={`flex max-w-[90%] flex-col gap-1 ${ln.side === 'B' ? 'self-end items-end' : 'self-start items-start'}`}
                  >
                    <span className="px-1 text-[11px] text-foreground-400">{ln.name}</span>
                    <div
                      className={`rounded-2xl px-3.5 py-2.5 text-xs leading-relaxed ${
                        ln.side === 'B'
                          ? 'rounded-tr-sm bg-primary-500 text-background-50'
                          : 'rounded-tl-sm bg-background-100 text-foreground-800'
                      }`}
                    >
                      {ln.text}
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-between border-t border-background-100 px-5 py-3.5">
                <span className="flex items-center gap-1.5 text-xs font-medium text-foreground-500">
                  <i className="ri-attachment-line" />
                  {e.meta}
                </span>
                <button
                  type="button"
                  className="flex items-center gap-1 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs font-bold text-foreground-700 transition hover:bg-background-200"
                  aria-label="查看原图"
                >
                  <i className="ri-image-2-line" />
                  原图
                </button>
              </div>
            </article>
          ))}

          {/* 置顶说明卡 */}
          <div className="flex flex-col justify-center rounded-3xl border border-dashed border-accent-300 bg-accent-50/60 p-7">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-accent-500 text-xl text-background-50">
              <i className="ri-information-2-fill" />
            </span>
            <h3 className="mt-4 font-heading text-lg font-black text-foreground-950">实锤也得讲证据</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              聊天记录、群内投票与截图都有打码与时间戳说明。若你有独家一手素材，欢迎到前台递料，核过再上架。
            </p>
            <a
              href="#commentBox"
              className="mt-5 inline-flex items-center gap-2 self-start whitespace-nowrap rounded-full bg-accent-500 px-4 py-2.5 text-sm font-bold text-background-50 transition hover:bg-accent-600"
            >
              递一手素材
              <i className="ri-upload-2-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}